import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'antera-lib-kanban-search-container',
  templateUrl: './kanban-search-container.component.html',
  styleUrls: ['./kanban-search-container.component.scss']
})
export class KanbanSearchContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {}

}
